import { Button, Form, Mentions, Select, Switch } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { getFiles } from '../../../../services/assistant'
import { InputSearch } from '../../../input-search'
import { EnterOutlined, UploadOutlined } from "@ant-design/icons";
import PublicFile from "../../../public-file";

const modes = [
  {
    label: "Imagens do conhecimento/prompt",
    value: "AI_IMAGES"
  },
  {
    label: "Imagens fixas",
    value: "IMAGES"
  }
]

export default function SendImage({ fieldName, parameters, form }) {
  const mode = Form.useWatch(['actions', fieldName, 'action', 'data', 'mode'], form)

  const availableArrayString = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type, items }) => type === 'array' && items?.type === 'string')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item name={[fieldName, 'action', 'data', 'mode']}
        initialValue={'IMAGES'}
        label={'Modo dos imagens'}>
        <Select options={modes} placement={"Selecione o modo de imagens"} />
      </Form.Item>
      {mode === 'IMAGES' && (
        <Form.Item
          label="Imagens fixas"
          name={[fieldName, 'action', 'data', 'images']}
          rules={[{
            required: true,
            message: "É obrigatório adicionar pelo menos uma imagem.",
          }]}
        >
          <PublicFile multiple image>
            <Button icon={<UploadOutlined />}>Subir Arquivo</Button>
          </PublicFile>
        </Form.Item>
      )}
      {mode === 'AI_IMAGES' && <Form.Item
        label={'Imagens do prompt ou conhecimento'}
        name={[fieldName, 'action', 'data', 'aiImages']}
        help={'Selecione um parametro do gatilho que seja uma lista de textos'}
      >
        <Select placeholder={'Selecione um parametro do gatilho'} options={availableArrayString} />
      </Form.Item>}
    </>
  )
}
